<div class="modal-content">
  <div class="div-message-box animated fadeIn fast">
    <div class="message-box-container animated fadeIn fast">
      
      <div class="message-box-middle">
        
        <!-- Loading Spinner -->
        @if (loading) {
<div class="loading-section">
          <i class="fa fa-spinner fa-spin"></i>
          <span class="loading-text">Processing...</span>
        </div>
}

        <!-- Confirmation Content -->
        @if (!loading) {
<div>
          <span class="msg-title">
            <i class="fa fa-sign-out txt-color-orangeDark"></i>{{ title }}
          </span>
          <p class="p-text">Do you want to apply default 163j tags?</p>
          
          <div class="message-box-button-section">
            <button 
              class="btn btn-default btn-xs" 
              id="switch-no" 
              (click)="cancel()"
              [disabled]="processing"> 
              No
            </button>
            <button 
              class="btn btn-danger btn-xs" 
              id="switch-yes" 
              (click)="confirmSync()"
              [disabled]="processing"> 
              Yes
            </button>
            
          </div>
        </div>
}
      </div>
    </div>
  </div>
</div>
